import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MainMenuItem } from '../../../layout-constants';
import { MenuService } from '../../menu.service';

@Component({
  selector: 'app-custom-menu-tree-item',
  templateUrl: './custom-menu-tree-item.component.html',
  styleUrls: ['./custom-menu-tree-item.component.scss']
})
export class CustomMenuTreeItemComponent {

  @Input('menuItem') public menuItem: MainMenuItem;
  @Input('isTabbed') public isTabbed: boolean;

  @Output('onClick') public onMenuClick: EventEmitter<MainMenuItem> = new EventEmitter();

  constructor(public menuService: MenuService) {
  }

}
